import { Container } from "components";
import CustomDatepicker from "components/CustomDatePicker";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useToaster } from "hooks";
import JoditEditor from "jodit-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import api from "services/api";
import * as Yup from "yup";

const initialValues = {
  name: "",
  address: "",
  contract_start_date: null,
  contract_end_date: null,
  contact_info: "",
  contact_person: "",
  partner_contact_number: "",
  inclusions: "",
  exclusions: "",
  price: "",
  email: "",
  categories: [],
  // discount_price: "",
  latitude: "",
  longitude: "",
  industry_id: [],
  city_id: "",
  landmark: "",
  area_name: "",
  description: "",
  status: "Active",
  logo: null,
  logo_url: "",
};
const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  contract_start_date: Yup.date()
    .transform((value, originalValue) =>
      moment(originalValue, "DD-MM-YYYY", true).isValid()
        ? moment(originalValue, "DD-MM-YYYY").toDate()
        : null
    )
    .nullable(),
  contract_end_date: Yup.date()
    .transform((value, originalValue) =>
      moment(originalValue, "DD-MM-YYYY", true).isValid()
        ? moment(originalValue, "DD-MM-YYYY").toDate()
        : null
    )
    .nullable()
    .when("contract_start_date", {
      is: (val) => val !== null && val !== undefined && val !== "",
      then: (schema) =>
        schema.min(
          Yup.ref("contract_start_date"),
          "Contract end date must be after the start date"
        ),
    }),
  contact_info: Yup.string().required("Required"),
  contact_person: Yup.string().required("Required"),
  partner_contact_number: Yup.string()
    .required("Partner contact number is required")
    .matches(/^[0-9]{10}$/, "Partner contact number must be exactly 10 digits"),
  //   inclusions: Yup.string(),
  exclusions: Yup.string(),
  email: Yup.string()
    .email("Invalid email format")
    .matches(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      "Invalid email format"
    )
    .required("Required"),
  categories: Yup.array()
    .min(1, "At least one category is required")
    .required("Required"),
  price: Yup.number().typeError("Price must be a number").required("Required"),
  // discount_price: Yup.string().required("Required"),
  latitude: Yup.number().typeError("Latitude must be a number").required("Required"),
  longitude: Yup.number().typeError("Longitude must be a number").required("Required"),
  industry_id: Yup.array()
    .min(1, "At least one industry is required")
    .required("Required"),
  city_id: Yup.string().required("Required"),
  landmark: Yup.string(),
  area_name: Yup.string(),
  description: Yup.string()
    .required("Description is required")
    .test(
      "maxWords",
      "Description must not exceed 1000 words",
      (value) => {
        if (!value) return true;
        // Strip HTML tags and count words
        const textContent = value.replace(/<[^>]*>/g, " ").trim();
        const words = textContent.split(/\s+/).filter((word) => word.length > 0);
        return words.length <= 1000;
      }
    ),
  status: Yup.string()
    .oneOf(["Active", "Inactive"], "Status must be Active or Inactive")
    .required("Status is required"),
  logo: Yup.mixed()
    .test("fileSize", "Logo must be less than 2MB", (file) => {
      if (!file) return true; // optional
      return file.size <= 2 * 1024 * 1024;
    })
    .test("fileType", "Only jpg, jpeg, png, svg allowed", (file) => {
      if (!file) return true;
      const allowed = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"];
      return allowed.includes(file.type);
    })
    .test(
      "imageDimensions",
      "Max dimensions 2048x2048",
      (file) =>
        new Promise((resolve) => {
          if (!file || file.type === "image/svg+xml") return resolve(true);
          const img = new Image();
          img.onload = () => {
            resolve(img.width <= 2048 && img.height <= 2048);
          };
          img.onerror = () => resolve(false);
          img.src = URL.createObjectURL(file);
        })
    ),
});
export const EditPartner = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [deta, setDeta] = useState({ ...initialValues });
  const { setSuccessToaster, setErrorToaster } = useToaster();
  const [industries, setIndustries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);

  const fetchCities = async () => {
    try {
      const response = await api.get("/cities");
      const result = response?.data?.data?.cities || [];
      setCities(result);
      console.log("fetchCities:", result);
    } catch (error) {
      console.log("fetchCities Error:", error);
    }
  };

  const fetchIndustries = async () => {
    try {
      const response = await api.get("/industries");
      const result = response?.data?.data || [];
      setIndustries(result);
      console.log("fetchIndustries:", result);
    } catch (error) {
      console.log("fetchIndustries Error:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await api.get("/partner-categories");
      const result = response?.data?.data?.partner_categories || [];
      setCategories(result);
      console.log("fetchCategories:", result);
    } catch (error) {
      console.log("fetchCategories Error:", error);
    }
  };

  // here edit function start
  const handlePartnerDetails = (details) => {
    const {
      address,
      contact_info,
      contract_end_date,
      contract_start_date,
      created_at,
      discount_price,
      email,
      contact_person,
      partner_contact_number,
      exclusions,
      inclusions,
      latitude,
      longitude,
      name,
      price,
      industry_id,
      industry,
      industries: partnerIndustries,
      categories: partnerCategories,
      city_id,
      city,
      landmark,
      area_name,
      description,
      status,
    } = details;
    
    // Handle industries - could be array, single object, or need to construct from industry_id
    let industriesArray = [];
    if (partnerIndustries && Array.isArray(partnerIndustries)) {
      industriesArray = partnerIndustries;
    } else if (industry) {
      // Single industry object
      industriesArray = [industry];
    } else if (industry_id && details.industries) {
      // Fallback: check if industries exists in details
      industriesArray = Array.isArray(details.industries) ? details.industries : [];
    }
    
    const updateData = {
      address: address,
      contact_info: contact_info,
      contract_end_date: contract_end_date
        ? moment(contract_end_date, "YYYY-MM-DD").format("DD-MM-YYYY")
        : null,
      contract_start_date: contract_start_date
        ? moment(contract_start_date, "YYYY-MM-DD").format("DD-MM-YYYY")
        : null,
      created_at: created_at,
      discount_price: discount_price,
      email: email,
      exclusions: exclusions,
      inclusions: inclusions,
      latitude: latitude,
      contact_person: contact_person,
      partner_contact_number: partner_contact_number || "",
      longitude: longitude,
      name: name,
      price: price,
      industry_id: industriesArray.length > 0
        ? industriesArray.map((ind) => ({
            value: ind.industry_id || ind.id,
            label: ind.name,
          }))
        : [],
      categories: partnerCategories
        ? partnerCategories.map((cat) => ({
            value: cat.category_id,
            label: cat.name,
          }))
        : [],
      city_id: city_id || (city ? city.city_id || city.id : ""),
      landmark: landmark || "",
      area_name: area_name || "",
      description: description || "",
      status: status || "Active",
      logo: null,
      logo_url: details.logo_url || "",
    };
    setDeta(updateData);
  };
  const fetchPartnerDetails = async () => {
    try {
      const response = await api.get(`/partners/${params.id}`);
      const details = response?.data?.data?.partner;
      if (details) {
        handlePartnerDetails(details);
        console.log("details", details);
      }
    } catch (error) {
      console.log("fetchPartnerDetails error:");
    }
  };
  useEffect(() => {
    if (params.id) {
      fetchPartnerDetails();
    }
    fetchIndustries();
    fetchCategories();
    fetchCities();
  }, []);
  // here edit function end
  const handleSubmit = async (values) => {
    const payLoad = new FormData();
    
    Object.keys(values).forEach((key) => {
      // Skip logo_url as it's not needed in the request
      if (key === "logo_url") {
        return;
      }
      
      // Handle logo file upload
      if (key === "logo") {
        if (values.logo instanceof File) {
          payLoad.append("logo", values.logo);
        }
        // If logo is null/undefined, don't append it (optional field)
        return;
      }
      
      if (key === "contract_start_date" || key === "contract_end_date") {
        // Send null if date is empty, otherwise send the value
        const dateValue = values[key];
        payLoad.append(key, dateValue && dateValue !== "" ? dateValue : null);
      } else if (key === "categories") {
        // Send categories as category_id array
        const categoryIds = values[key].map((cat) => cat.value || cat);
        categoryIds.forEach((id) => {
          payLoad.append("category_id[]", id);
        });
      } else if (key === "industry_id") {
        // Send industry_id as array of IDs
        const industryIds = values[key].map((ind) => ind.value || ind);
        industryIds.forEach((id) => {
          payLoad.append("industry_id[]", id);
        });
      } else if (key === "partner_contact_number") {
        // Send partner_contact_number as contact_number
        payLoad.append("contact_number", values[key] ?? "");
      } else {
        payLoad.append(key, values[key] ?? "");
      }
    });
    if (params?.id) {
      //throgh params if(edit)
      try {
        const response = await api.post(`/partners/${params?.id}`, payLoad);
        if (response?.status === 201) {
          setSuccessToaster(response?.data?.message);
          navigate("/partners");
          console.log("handleSubmit", response);
        }
      } catch (error) {
        console.log("handleSubmitEdit Error:", error);
        setErrorToaster(error?.response?.data?.message);
      }
    } else {
      //if not params (add partner)
      try {
        const response = await api.post("/partners", payLoad);
        console.log("handleSubmit", response);
        if (response?.status === 201) {
          setSuccessToaster(response?.data?.message);
          navigate("/partners");
        }
        // setSuccessToaster()
      } catch (error) {
        console.log("handleSubmit add Error:", error);
        setErrorToaster(error?.response?.data?.message);
      }
    }
  };
  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/partners">Partners</Link>
              </li>
              <li class="breadcrumb-item active ">
                {params?.id ? "Edit" : "Add"} partner
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-12">
              <Formik
                initialValues={deta}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  handleSubmit(values);
                  console.log("values", values);
                }}
                enableReinitialize
              >
                {({ values, errors, setFieldValue }) => {
                  return (
                    <Form>
                      {console.log("checking", values.contract_start_date)}
                      {console.log("checking end", values.contract_end_date)}
                      {console.log("errors:", errors)}
                      {console.log("values", values)}
                      <div className="card mb-4">
                        <h5 className="card-header">
                          {params?.id ? "Edit" : "Add"} partner
                        </h5>
                        <hr className="my-0" />
                        <div className="card-body">
                          {/* Basic Information Section */}
                          <h6 className="mb-3 text-primary fw-semibold">Basic Information</h6>
                          <div className="row mb-4">
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Name <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                name="name"
                                onChange={(e) => {
                                  if (/^[A-Za-z ]*$/.test(e.target.value)) {
                                    setFieldValue("name", e.target.value);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Email <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="email"
                                className="form-control"
                                placeholder="Enter your Email"
                                name="email"
                                onChange={(e) => {
                                  const email = e.target.value;
                                  const isValidEmail = /^[A-Za-z0-9@.]/.test(
                                    email
                                  );
                                  if (isValidEmail) {
                                    setFieldValue("email", email);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Categories <span className="invalid-form">*</span>
                              </label>
                              <Select
                                isMulti
                                name="categories"
                                options={categories.map((cat) => ({
                                  value: cat.category_id || cat.id,
                                  label: cat.name,
                                }))}
                                value={values.categories}
                                onChange={(selectedOptions) => {
                                  setFieldValue("categories", selectedOptions || []);
                                }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select categories..."
                              />
                              {errors.categories && (
                                <div className="invalid-form">
                                  {errors.categories}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Location Details Section */}
                          <h6 className="mb-3 text-primary fw-semibold mt-4">Location Details</h6>
                          <div className="row mb-4">
                            <div className="col-md-12 col-12 mb-3">
                              <label className="form-label">
                                Address <span className="invalid-form">*</span>
                              </label>
                              <Field
                                as="textarea"
                                className="form-control"
                                rows="3"
                                placeholder="Address"
                                name="address"
                              />
                              <ErrorMessage
                                name="address"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Landmark
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Landmark"
                                name="landmark"
                              />
                              <ErrorMessage
                                name="landmark"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Area Name
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Area Name"
                                name="area_name"
                              />
                              <ErrorMessage
                                name="area_name"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Location (City) <span className="invalid-form">*</span>
                              </label>
                              <Field
                                as="select"
                                className="select2 form-select"
                                name="city_id"
                              >
                                <option value="">Select</option>
                                {cities.map((city) => (
                                  <option key={city.city_id} value={city.city_id}>
                                    {city.name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="city_id"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-md-6 col-12 mb-3">
                              <label className="form-label">
                                Latitude <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="tel"
                                className="form-control"
                                name="latitude"
                                placeholder="Latitude"
                                onChange={(e) => {
                                  if (/^[0-9.]*$/.test(e.target.value)) {
                                    setFieldValue("latitude", e.target.value);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="latitude"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-6 col-12 mb-3">
                              <label className="form-label">
                                Longitude <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="tel"
                                className="form-control"
                                name="longitude"
                                placeholder="Longitude"
                                onChange={(e) => {
                                  if (/^[0-9.]*$/.test(e.target.value)) {
                                    setFieldValue("longitude", e.target.value);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="longitude"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>

                          {/* Contact Information Section */}
                          <h6 className="mb-3 text-primary fw-semibold mt-4">Contact Information</h6>
                          <div className="row mb-4">
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Office Contact Number <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="tel"
                                className="form-control"
                                placeholder="Office Contact Number"
                                name="contact_info"
                                maxLength="10"
                                onChange={(e) => {
                                  if (/^[0-9]*$/.test(e.target.value)) {
                                    setFieldValue(
                                      "contact_info",
                                      e.target.value
                                    );
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="contact_info"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Contact Person <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Contact Person"
                                name="contact_person"
                                onChange={(e) => {
                                  if (/^[A-Za-z ]*$/.test(e.target.value)) {
                                    setFieldValue(
                                      "contact_person",
                                      e.target.value
                                    );
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="contact_person"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Partner Contact Number <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="tel"
                                className="form-control"
                                placeholder="Partner Contact Number"
                                name="partner_contact_number"
                                maxLength="10"
                                onChange={(e) => {
                                  if (/^[0-9]*$/.test(e.target.value)) {
                                    setFieldValue(
                                      "partner_contact_number",
                                      e.target.value
                                    );
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="partner_contact_number"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>

                          {/* Business Details Section */}
                          <h6 className="mb-3 text-primary fw-semibold mt-4">Business Details</h6>
                          <div className="row mb-4">
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Cashback Percentage % <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="number"
                                className="form-control"
                                name="price"
                                placeholder="Cashback Percentage %"
                                onChange={(e) => {
                                  if (/^[0-9]*$/.test(e.target.value) && parseInt(e.target.value) <= 100) {
                                    setFieldValue("price", e.target.value);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="price"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                              <label className="form-label">
                                Status <span className="invalid-form">*</span>
                              </label>
                              <Field
                                as="select"
                                className="select2 form-select"
                                name="status"
                              >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </Field>
                              <ErrorMessage
                                name="status"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-md-6 col-12 mb-3">
                              <label className="form-label">
                                Contract Start Date
                              </label>
                              <Field
                                className="form-control"
                                name="contract_start_date"
                                value={values.contract_start_date}
                                component={CustomDatepicker}
                              />
                              <ErrorMessage
                                name="contract_start_date"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-6 col-12 mb-3">
                              <label className="form-label">
                                Contract End Date
                              </label>
                              <Field
                                className="form-control"
                                name="contract_end_date"
                                value={values.contract_end_date}
                                component={CustomDatepicker}
                                min={
                                  values.contract_start_date
                                    ? moment(
                                        values.contract_start_date,
                                        "DD-MM-YYYY"
                                      ).toDate()
                                    : null
                                }
                              />
                              <ErrorMessage
                                name="contract_end_date"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-md-8 col-12 mb-3">
                              <label className="form-label">
                                Services <span className="invalid-form">*</span>
                              </label>
                              <Select
                                isMulti
                                name="industry_id"
                                options={industries.map((industry) => ({
                                  value: industry.id,
                                  label: industry.name,
                                }))}
                                value={values.industry_id}
                                onChange={(selectedOptions) => {
                                  setFieldValue("industry_id", selectedOptions || []);
                                }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select services..."
                              />
                              {errors.industry_id && (
                                <div className="invalid-form">
                                  {errors.industry_id}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Description Section */}
                          <h6 className="mb-3 text-primary fw-semibold mt-4">Description</h6>
                          <div className="row mb-4">
                            <div className="col-md-12 col-12 mb-3">
                              <label className="form-label">
                                Description <span className="invalid-form">*</span>
                              </label>
                              <JoditEditor
                                value={values.description}
                                onChange={(newContent) =>
                                  setFieldValue("description", newContent)
                                }
                              />
                              {errors.description && (
                                <div className="invalid-form">
                                  {errors.description}
                                </div>
                              )}
                              {values.description && (
                                <div className="mt-2">
                                  <small className="text-muted">
                                    Word count:{" "}
                                    {values.description
                                      .replace(/<[^>]*>/g, " ")
                                      .trim()
                                      .split(/\s+/)
                                      .filter((word) => word.length > 0).length}
                                    /1000
                                  </small>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* Additional Information Section */}
                          <h6 className="mb-3 text-primary fw-semibold mt-4">Additional Information</h6>
                          <div className="row mb-4">
                            <div className="col-md-6 col-12 mb-3">
                              <label className="form-label">Exclusions</label>
                              <JoditEditor
                                value={values.exclusions}
                                onChange={(newContent) =>
                                  setFieldValue("exclusions", newContent)
                                }
                              />
                            </div>
                            <div className="col-md-6 col-12 mb-3">
                              <label className="form-label">Inclusions</label>
                              <JoditEditor
                                value={values.inclusions}
                                onChange={(newContent) =>
                                  setFieldValue("inclusions", newContent)
                                }
                              />
                            </div>
                          </div>

                          {/* Logo Section */}
                          <h6 className="mb-3 text-primary fw-semibold mt-4">Logo</h6>
                          <div className="row mb-4">
                            <div className="col-md-6 col-12 mb-3">
                              {params?.id && values.logo_url && (
                                <div className="mb-3">
                                  <label className="form-label d-block">Current Logo</label>
                                  <img
                                    src={values.logo_url}
                                    alt="Partner logo"
                                    style={{ maxHeight: "100px", maxWidth: "100%", objectFit: "contain", border: "1px solid #eee", padding: "4px", borderRadius: "4px" }}
                                  />
                                </div>
                              )}
                              <label className="form-label">Logo (optional)</label>
                              <input
                                type="file"
                                accept="image/jpeg,image/jpg,image/png,image/svg+xml"
                                className="form-control"
                                name="logo"
                                onChange={(e) => {
                                  const file = e.currentTarget.files && e.currentTarget.files[0];
                                  if (file) {
                                    setFieldValue("logo", file);
                                  } else {
                                    setFieldValue("logo", null);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="logo"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <button
                            className="btn btn-primary d-grid w-100"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
